import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { initialOperation, isUserInfo } from "./data/userInfo";
import { CircularProgress } from "@mui/material";
import { useAccessLog } from "./accessLog/useAccessLog";
import { useAppSelector } from "./app/hooks";
import { selectAuthLoading } from "./features/authSlice";
import { initFirebaseAuth } from "./firebase/firebase";

const ProtectedRoute = () => {
    const authLoading = useAppSelector(selectAuthLoading);
    const [fallbackDone, setFallbackDone] = useState(false);

    // アクセスログを自動送信
    useAccessLog();

    useEffect(() => {
        if (!authLoading && !isUserInfo() && !fallbackDone) {
            const tryAuth = async () => {
                const user = await initFirebaseAuth();
                if (user) {
                    // Firebase セッションが残っている場合はユーザー情報を取得
                    await initialOperation();
                    return;
                }
                // Firebase セッションなし → App.tsx の Cookie 認証を経由
                const currentPath = window.location.pathname.replace(/^\//, '');
                const currentSearch = window.location.search;
                const modeParam = `mode=${encodeURIComponent(currentPath)}`;
                const otherParams = currentSearch ? currentSearch.substring(1) : '';
                window.location.href = `/?${modeParam}${otherParams ? '&' + otherParams : ''}`;
            };
            tryAuth()
                .catch((e) => console.error("ProtectedRoute: 認証フォールバックエラー:", e))
                .finally(() => setFallbackDone(true));
        }
    }, [authLoading, fallbackDone]);

    if (authLoading) {
        return (
            <div style={{ justifyContent: "center", display: "flex" }}>
                <CircularProgress
                    size={"40vh"}
                    style={{ color: "#ccc", top: "30vh", position: "absolute" }}
                />
            </div>
        );
    }

    if (isUserInfo()) {
        return <Outlet />;
    }

    if (!fallbackDone) {
        return (
            <div style={{ justifyContent: "center", display: "flex" }}>
                <CircularProgress
                    size={"40vh"}
                    style={{ color: "#ccc", top: "30vh", position: "absolute" }}
                />
            </div>
        );
    }

    // フォールバックも失敗した場合
    console.log("ProtectedRoute: 認証失敗、空のコンポーネントを返します");
    return <></>;
}

export default ProtectedRoute;
